import moment from "moment";
import React from "react";
import submit from "submit-form";
import { getWeekColumnData } from "../../../../../utils/annual-planner-helpers";

export const PhasesDescriptionBubbles = ({
  numberOfWeeks,
  month,
  startingCalendarDay,
  exactWeek,
  phasesDescriptions,
}) => {
  return (
    //   This is the row containing the description bubbles
    <div className="phases-descriptions-wrapper">
      {Array.from(Array(numberOfWeeks).keys(), (weekNumber, index) => {
        const weekFirstDay = getWeekColumnData(
          month,
          startingCalendarDay,
          weekNumber
        );
        // We show one per week
        return (
          <DescriptionBubble
            key={`description-bubble-${index}-${Math.random()
              .toString(16)
              .slice(2)}`}
            weekFirstDay={weekFirstDay}
            exactWeek={exactWeek}
            phasesDescriptions={phasesDescriptions}
          />
        );
      })}
    </div>
  );
};

const DescriptionBubble = ({ weekFirstDay, phasesDescriptions }) => {
  // Getting the last day of the week to handle the range between which the phase description could exist
  const weekLastDay = moment(weekFirstDay).add(6, "days");

  // We get the current description object corresponding to the current week (if exists)
  const phaseDescriptionObject =
    phasesDescriptions &&
    phasesDescriptions.find((description) =>
      moment(description.dateAttachment, "YYYYMMDD").isBetween(
        moment(weekFirstDay),
        moment(weekLastDay),
        undefined,
        "[]"
      )
    );

  // Handler for opening a modal with the description information
  const openPhaseDescriptionModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "phase-description",
        dateAttachment: phaseDescriptionObject
          ? moment(phaseDescriptionObject.dateAttachment, "YYYYMMDD").format(
              "MMM D, YYYY"
            )
          : moment(weekFirstDay).format("MMM D, YYYY"),
        phaseDescriptionStatus: phaseDescriptionObject ? "read" : "edit",
        phaseDescription: phaseDescriptionObject
          ? phaseDescriptionObject.phaseDescription
          : "",
      },
    });
  };

  return (
    <div
      className={`phase-description-bubble${
        phaseDescriptionObject ? " active" : ""
      }`}
      onClick={openPhaseDescriptionModal}
    >
      <img src="/img/new-icons/message-icon.svg" />
    </div>
  );
};
